<style scoped>

</style>

<template>
  <component
    :is="component"
    :layout="layout"
    :mediaId="mediaId"
    :media="media"
    :playlist="playlist"
    :playlistId="playlistId"
    :channel="channel"
    :flagReactionDetailShow="flagReactionDetailShow"
    :flagPauseSwitch="flagPauseSwitch"
    :timestamp="timestamp"
    :timestampTrigger="timestampTrigger"
    :currentTime="currentTime"
    :overlays="overlays"
    :isAdmin="isAdmin"
    :adminUserIds="adminUserIds"
    :tag="tag"
    :tagTrigger="tagTrigger"
    :playerState="playerState"
    @onUpdateTime="onUpdateTime"
    @onPause="onPause"
    @onPlay="onPlay"
    @onClickTimestamp="onClickTimestamp"
    @onUpdateLayout="onUpdateLayout"
    @onUpdateMedia="onUpdateMedia"
    @onClickTag="$emit('onClickTag', $event)"
    @onPlayerState="onPlayerState"
    :startFrom="startFrom"
    />
</template>

<script>

// Components
import PlaylistPanel from '@/components/Playlist/PlaylistPanel.vue'

import MediaPanel from '@/components/Media/MediaPanel.vue'

import DiscussionTab from '@/components/Discussion/DiscussionTab.vue'
import QuizTab from '@/components/Quiz/QuizTab.vue'

import TimeCapsulePanel from '@/components/TimeCapsule/TimeCapsulePanel.vue'

export default {
  name: 'LayoutComponent',
  components: {
    PlaylistPanel,
    MediaPanel,
    DiscussionTab,
    QuizTab,
    TimeCapsulePanel,
  },
  props: {
    component: {
      type: String
    },
    layout: {
      type: Array,
      default() {
        return [];
      }
    },
    mediaId: {
      type: String
    },
    media: {
      type: Object
    },
    playlistId: {
      type: String
    },
    playlist: {
      type: Object
    },
    channel: {
      type: Object
    },
    flagReactionDetailShow: {
      type: Boolean
    },
    flagPauseSwitch: {
      type: Boolean
    },
    timestamp: {
      type: Number
    },
    currentTime: {
      type: Number
    },
    isAdmin: {
      type: Boolean
    },
    overlays: {
      type: Array
    },
    adminUserIds: {
      type: Array
    },
    timestampTrigger: {
      type: Boolean,
      default: false
    },
    tag: {
      type: Object,
      default() {
        return {
          action: '',
          tagId: ''
        }
      }
    },
    tagTrigger: {
      type: Boolean,
      default: false
    },
    playerState: {
      type: Object,
      default() {
        return {}
      }
    },
    startFrom: {
      type: String
    }
  },
  data() {
    return {
    
    }
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  methods: {
    onUpdateTime(payload) {
      this.$emit('onUpdateTime', payload);
    },
    onPause() {
      this.$emit('onPause');
    },
    onPlay() {
      this.$emit('onPlay');
    },
    onClickTimestamp(payload) {
      this.$emit('onClickTimestamp', payload);
    },
    onUpdateLayout(payload) {
      this.$emit('onUpdateLayout', payload);
    },
    onUpdateMedia(payload) {
      this.$emit('onUpdateMedia', payload);
    },
    onPlayerState(payload) {
      this.$emit('onPlayerState', payload);
    },
  },
}
</script>
